export var ListClickEvents;
(function (ListClickEvents) {
    ListClickEvents["ListClick"] = "list_click";
    ListClickEvents["FaqClick"] = "faq_click";
})(ListClickEvents || (ListClickEvents = {}));
export var ListStyles;
(function (ListStyles) {
    ListStyles["Standard"] = "standard";
    ListStyles["RelatedResources"] = "related-resources";
    ListStyles["BlueLinks"] = "blue-links";
    ListStyles["Arrow"] = "arrow";
    ListStyles["Footer"] = "footer";
    ListStyles["Navigation"] = "navigation";
    ListStyles["HorizontalArrows"] = "horizontal-arrows";
})(ListStyles || (ListStyles = {}));
//# sourceMappingURL=types.js.map